import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import template from './downtimeReport.tpl.html';
import {StateParams} from "../../common";
import {apsEnums} from "../../shared/dto/aps.enums";
import {ICommonQueryingReport} from "./commonQueryingReport";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import {Colors, States} from "../../shared/config/constant.module";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";

let requires = [UIUtilityServiceName, LoaderServiceName, ReportServiceName, NavigationServiceName];

export interface DowntimeReportParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
  type: apsEnums.DowntimeType;
  location: apsEnums.DowntimeLocation;
  orderBy: apsEnums.DowntimeOrder;
  showAll: string;
  autoRun: boolean;
}
  
class DowntimeReportCtrl implements ICommonQueryingReport {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  startDate: Date;
  endDate: Date;
  uiStartDate: Date;
  uiEndDate: Date;
  types: EnumOption[];
  locations: EnumOption[];
  orderBys: EnumOption[];
  type: apsEnums.DowntimeType;
  location: apsEnums.DowntimeLocation;
  orderBy: apsEnums.DowntimeOrder;
  showAll: boolean;
  
  reportStartDate: Date;
  reportEndDate: Date;
  reportShopId: string;
  reportShopName: string;
  reportTimeZoneId: string;
  reportDetailsSection: string;
  reportDetailsType: apsEnums.DowntimeType;

  form: angular.IFormController;

  searchPerformed: boolean;
  downtimeSummaries: apsViewModels.DowntimeSummaryReportItem[];
  downtimeSummariesPretty: any[];
  detailsReportGenerated: boolean;
  defectType: string;
  downtimeDetails: apsViewModels.DowntimeDetailsReportItem[];
  typeToColor: {[type: string]: string};

  preventativeText: string;
  nonPreventativeText: string;
  machineSectionText: string;

  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  uiUtilityService: UIUtilityService;

  scopeWorkaround: {
    downtimeBarClick(dimpleEvent: {
      xValue: string;
      seriesValue: string[];
    }): void;
  };

  requirePlantSelection: boolean;
  requireShopSelection: boolean;
  private $q: angular.IQService;
  private $timeout: angular.ITimeoutService;
  private $stateParams: DowntimeReportParams;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: DowntimeReportParams,
    navigationService: NavigationService,
    reportService: ReportService,
    loaderService: LoaderService,
    uiUtilityService: UIUtilityService,
    $timeout: angular.ITimeoutService,
    $q: angular.IQService) {

    let vm = this;

    vm.$state = $state;
    vm.$stateParams = $stateParams;
    vm.loaderService = loaderService;
    vm.reportService = reportService;
    vm.uiUtilityService = uiUtilityService;
    vm.$q = $q;
    vm.$timeout = $timeout;
    vm.defectType = '';

    vm.preventativeText = 'Preventative';
    vm.nonPreventativeText = 'Corrective';
    // vm.machineSectionText = 'Machine';

    vm.typeToColor = this.getTypeToColorMappings();

    vm.requirePlantSelection = true;
    vm.requireShopSelection = true;

    var now = moment().add(1, 'hours').startOf('hour');
    vm.uiEndDate = now.toDate();
    vm.uiStartDate = now.clone().subtract(1, 'days').toDate();

    vm.types = uiUtilityService.getListOptionsFromEnum(apsEnums.DowntimeType);
    vm.locations = uiUtilityService.getListOptionsFromEnum(apsEnums.DowntimeLocation);
    vm.orderBys = uiUtilityService.getListOptionsFromEnum(apsEnums.DowntimeOrder, 1);
    vm.type = apsEnums.DowntimeType.All;
    vm.location = apsEnums.DowntimeLocation.All;
    vm.orderBy = apsEnums.DowntimeOrder.Time;
    vm.showAll = false;

    vm.scopeWorkaround = {
      downtimeBarClick: function (dimpleEvent) {
        if (dimpleEvent
            && !_.isUndefined(dimpleEvent.xValue)
            && dimpleEvent.seriesValue
            && dimpleEvent.seriesValue[0]) {

          var section = dimpleEvent.xValue;
          var isPreventative = vm.preventativeText === dimpleEvent.seriesValue[0];
          vm.getReportDetails(section, isPreventative ? apsEnums.DowntimeType.Preventative : apsEnums.DowntimeType.Corrective);
        }
      }
    };

    var promise = navigationService.getNavigation().then((navModel) => {
      vm.plants = navModel.plants();
      vm.selectedPlant = navModel.selectedPlant;
      vm.updatePlant();
      vm.selectedShop = navModel.selectedShop;

      return vm.loadState($stateParams);
    });

    loaderService.loadingPromise(promise);
  }

  private runReport(): angular.IPromise<any> {
    return this.reportService
      .getDowntimeReport(this.reportShopId, this.type, this.location, this.reportStartDate, this.reportEndDate)
      .then((downtimeSummaries) => {
        this.downtimeSummaries = downtimeSummaries;
        this.downtimeSummariesPretty = this.transformDowntimeSummariesPretty(downtimeSummaries);
        this.searchPerformed = true;
      });
  }

  defectTypes(): string[] {
    if (!this.detailsReportGenerated || !this.downtimeDetails || !this.downtimeDetails.length) {
      return [];
    }

    return _.uniq(_.filter(this.downtimeDetails, x => !!x.defectTypeName)
      .map(x => x.defectTypeName));
  }

  downtimeDetailsFiltered(): apsViewModels.DowntimeDetailsReportItem[] {
    if (!this.defectType) {
      return this.downtimeDetails;
    }

    return _.filter(this.downtimeDetails, x => x.defectTypeName === this.defectType);
  }

  loadState(params: DowntimeReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        var shop = _.find(plant.shops, {id: params.reportShopId});
        if (shop) {
          this.selectedPlant = plant;
          this.selectedShop = shop;
        }
      }
    }

    DateUtilityService.setReportDates(this, params, this.$timeout);

    if (params.type !== undefined) {
      var type = _.find(this.types, { value: +params.type }); // !!!
      if (type) {
        this.type = type.value;
      }
    }

    if (params.location !== undefined) {
      var location = _.find(this.locations, { value: +params.location }); // !!!
      if (location) {
        this.location = location.value;
      }
    }

    if (params.orderBy !== undefined) {
      var orderBy = _.find(this.orderBys, { value: +params.orderBy }); // !!!
      if (orderBy) {
        this.orderBy = orderBy.value;
      }
    }

    if (params.showAll === 'true') {
      this.showAll = true;
    }

    if (params.autoRun) {
      return this.runDowntimeReport();
    }

    return this.$q.when();
  }

  saveState() {
    var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }
    var params: DowntimeReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
      reportShopId: reportShopId,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      type: this.type,
      location: this.location,
      orderBy: this.orderBy,
      showAll: this.showAll.toString(),
      autoRun: true
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  private runDowntimeReport(): angular.IPromise<any> {
    this.reportShopId = this.selectedShop.id;
    this.reportShopName = this.selectedShop.name;
    this.reportStartDate = this.startDate;
    this.reportEndDate = this.endDate || new Date();
    this.reportTimeZoneId = this.selectedPlant.timeZoneId;

    this.downtimeSummaries = null;
    this.downtimeSummariesPretty = null;
    this.downtimeDetails = null;
    this.searchPerformed = false;
    this.detailsReportGenerated = false;

    if (this.showAll) {
      return this.getReportDetails('', this.type);
    }

    return this.runReport();
  }

  generateReport(): angular.IPromise<any> {
    if (this.form.$invalid) {
      return;
    }

    this.saveState();

    var loadPromise = this.runDowntimeReport();
    this.loaderService.loadingPromise(loadPromise);
    return loadPromise;
  }

  transformDowntimeSummariesPretty(downtimeSummaries: apsViewModels.DowntimeSummaryReportItem[]): any[] {
    return _.map(downtimeSummaries, (dts) => {
      return {
        // 'Machine': dts.machineName,
        'Section Number': (dts.machineName === 'A' ? 100 : 200) + (_.isNull(dts.section) ? 99 : dts.section),
        'Section Name': dts.machineName + (_.isNull(dts.section) ? '' : '/' + dts.section),
        'Total Minutes': dts.totalMinutes,
        Type: dts.preventative ? this.preventativeText : this.nonPreventativeText,
        'Type Order': dts.preventative ? 0 : 1
      };
    });
  }

  getReportDetails(section: string, type: apsEnums.DowntimeType): angular.IPromise<any> {
    this.reportDetailsSection = section;
    this.reportDetailsType = type;

    var loadPromise = this.reportService
      .getDowntimeReportDetails(this.reportShopId, type, this.location, section, this.reportStartDate, this.reportEndDate)
      .then((downtimeDetails) => {
        this.downtimeDetails = downtimeDetails;
        this.detailsReportGenerated = true;
        this.defectType = '';
      });

    this.loaderService.loadingPromise(loadPromise);

    return loadPromise;
  }

  getTypeToColorMappings(): any {
    var typeToColor = {};
    typeToColor[this.nonPreventativeText] = Colors.TOOL_CHANGE;
    return typeToColor;
  }

  formatTime(time: Date): string {
    return DateUtilityService.formatTime(time, this.reportTimeZoneId);
  }

  updatePlant(): void {
    this.selectedShop = null;
  }

  getOrderBy(): string[] {
    switch (this.orderBy) {
      case apsEnums.DowntimeOrder.Time:
        return ['startTime', 'downtimeType', '-duration', 'reason', 'tool', 'machineName', 'section', 'gob'];
      case apsEnums.DowntimeOrder.Type:
        return ['downtimeType', 'startTime', '-duration', 'reason', 'tool', 'machineName', 'section', 'gob'];
      case apsEnums.DowntimeOrder.Duration:
        return ['-duration', 'startTime', 'downtimeType', 'reason', 'tool', 'machineName', 'section', 'gob'];
      case apsEnums.DowntimeOrder.Reason:
        return ['reason', 'startTime', 'downtimeType', '-duration', 'tool', 'machineName', 'section', 'gob'];
      case apsEnums.DowntimeOrder.Comment:
        return ['comment', 'startTime', 'downtimeType', '-duration', 'reason', 'tool', 'machineName', 'section', 'gob'];
      case apsEnums.DowntimeOrder.Tool:
        return ['tool', 'startTime', 'downtimeType', '-duration', 'reason', 'machineName', 'section', 'gob'];
      case apsEnums.DowntimeOrder.Machine:
        return ['machineName', 'section', 'gob', 'startTime', 'downtimeType', '-duration', 'reason', 'tool'];
      case apsEnums.DowntimeOrder.Location:
        return ['section', 'gob', 'machineName', 'startTime', 'downtimeType', '-duration', 'reason', 'tool'];
      default:
        return ['startTime', 'downtimeType', '-duration', 'reason', 'tool', 'machineName', 'section', 'gob'];
    }
  }

  exportToCsv(): DowntimeReportItem[] {
    return _.map(this.downtimeDetailsFiltered(), (x): DowntimeReportItem => {
      return {
        time: this.formatTime(x.startTime),
        type: x.downtimeType,
        defectType: x.defectTypeName,
        duration: x.duration,
        reason: x.reason,
        comment: x.comment,
        tool: x.tool,
        machine: x.machineName,
        section: x.section,
        gob: x.gobName
      };
    });
  }
}

class DowntimeReportItem {
  time: string;
  type: string;
  defectType: string;
  duration: number;
  reason: string;
  comment: string;
  tool: string;
  machine: string;
  section: number;
  gob: string;
}

export default angular.module('aps.controller.downtimeReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.DOWNTIME_REPORT,
      url: '/admin/reports/downtime?startDate&endDate&type&location&orderBy&showAll&autoRun&reportPlantId&reportShopId',
      params: {
        startDate: {dynamic: true},
        endDate: {dynamic: true},
        type: {dynamic: true},
        location: {dynamic: true},
        orderBy: {dynamic: true},
        showAll: {dynamic: true},
        autoRun: {dynamic: true},
        reportPlantId: {dynamic: true},
        reportShopId: {dynamic: true},
      },
      controller: 'DowntimeReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Downtime Report'
      }
    });
  })
  .controller('DowntimeReportCtrl', DowntimeReportCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/downtimeReport.controller.ts